import $ from "jquery";
import _ from "lodash";
import ScrollMagic from "scrollmagic";
import { TweenMax, TimelineMax, TweenLite } from "gsap";
import "animation.gsap";
import "debug.addIndicators";

import controller from "../scroll/controller";

$(".block-sticky-pyramid").each(function() {
  let $block = $(this);
  let block = $block[0];
  let blockH = $block.height();

  let paddingT = $block.innerWidth() - $("img").width();

  let $sticky = $block.find(".sticky");
  let sticky = $sticky[0];
  let stickyH = $sticky.height();
  let scenes = [];

  let $texts = $block.find(".texts");
  let $text = $block.find(".text");
  let textCount = $text.length;

  let $text1 = $block.find(".text-1");
  let text1 = $text1[0];
  let text1H = $text1.height();
  let $text2 = $block.find(".text-2");
  let text2 = $text2[0];
  let text2H = $text2.height();

  let count = $text.length - 1;

  const tlText1 = new TimelineMax();
  const tlText2 = new TimelineMax();

  const flash = el => {
    let $el = $(el);
    if ($el.length) {
      $el.addClass("flash");
      setTimeout(function() {
        $el.removeClass("flash");
      }, 1000);
    }
  };

  tlText1
    .from("#layer-technique", 1, { opacity: 0, yPercent: -100 })
    .to("#layer-label-technique", 1, { color: "#2AD4CD" })
    .to("#layer-technique", 1, { opacity: 1, yPercent: 0 }, "=-1")
    .fromTo("#label-technique", 1, { opacity: 0 }, { opacity: 1 }, "=-1")

    .from("#layer-endurance", 1, { opacity: 0, yPercent: -100 })
    .to("#layer-label-endurance", 1, { color: "#78D94D" })
    .to("#layer-endurance", 1, { opacity: 1, yPercent: 0 }, "=-1")
    .fromTo("#label-endurance", 1, { opacity: 0 }, { opacity: 1 }, "=-1")

    .from("#layer-strength", 1, { opacity: 0, yPercent: -100 })
    .to("#layer-label-strength", 1, { color: "#FFEB00" })
    .to("#layer-strength", 1, { opacity: 1, yPercent: 0 }, "=-1")
    .fromTo("#label-strength", 1, { opacity: 0 }, { opacity: 1 }, "=-1")

    .from("#layer-speed", 1, { opacity: 0, yPercent: -100 })
    .to("#layer-label-speed", 1, { color: "#FF9D00" })
    .to("#layer-speed", 1, { opacity: 1, yPercent: 0 }, "=-1")
    .fromTo("#label-speed", 1, { opacity: 0 }, { opacity: 1 }, "=-1")

    .from("#layer-execution", 1, { opacity: 0, yPercent: -100 })
    .to("#layer-label-execution", 1, { color: "#FF4F2C" })
    .to("#layer-execution", 1, { opacity: 1, yPercent: 0 }, "=-1")
    .fromTo("#label-execution", 1, { opacity: 0 }, { opacity: 1 }, "=-1");

  tlText2
    .to("#pyramid", 1, { rotation: 90 })
    .from("#pyramid-graph", 0.5, { opacity: 0 })
    .to("#pyramid-graph", 0.5, { opacity: 1 });

  const deleteScenes = () => {
    if (scenes.length) {
      scenes.forEach(function(scene) {
        scene.destroy(true);
      });
    }
  };

  const blockScenes = () => {
    blockH = $block.height();
    stickyH = $sticky.height();

    const pinScene = new ScrollMagic.Scene({
      duration: blockH - stickyH,
      offset: stickyH / 2 + 120,
      triggerHook: "onCenter",
      triggerElement: block
    })
      .setPin(sticky)
      .addIndicators()
      .addTo(controller);

    scenes.push(pinScene);
  };

  const textScenes = () => {
    const textScene1 = new ScrollMagic.Scene({
      duration: text1H - stickyH,
      offset: stickyH / 2,
      triggerHook: "onCenter",
      triggerElement: text1
    })
      .setTween(tlText1)
      .addIndicators()
      .addTo(controller);

    const textScene2 = new ScrollMagic.Scene({
      duration: text2H,
      offset: 0,
      triggerHook: "onCenter",
      triggerElement: text2
    })
      .setTween(tlText2)
      .addIndicators()
      .addTo(controller);

    scenes.push(textScene1);
    scenes.push(textScene2);
  };

  const init = () => {
    deleteScenes();
    if (window.innerWidth > 768) {
      blockScenes();
      textScenes();
    }
  };

  init();
  $(window).on("resize", _.debounce(init, 100));
});
